import { getSuggestedCancellationDate } from "../../utils/cancellationHelper";

const formatDateTime = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleString('pl-PL', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  });
};

const markInvalidInput = (containerRef, fieldName) => {
  const input = containerRef.current.querySelector(`[name='${fieldName}']`);
  if (input) {
    input.classList.add("invalidInput");
    input.scrollIntoView({ behavior: "smooth", block: "center" });
    input.focus();
  }
};

const validateVariantInputs = (containerRef) => {
  const inputs = containerRef.current.querySelectorAll("input, textarea, select");
  let isValid = true;

  inputs.forEach((input) => {
    if (!input.checkValidity()) {
      input.classList.add("invalidInput"); 
      input.reportValidity();
      isValid = false;
    } else {
      input.classList.remove("invalidInput");
    }
  });

  const registrationStartDate = containerRef.current.querySelector("[name='registrationStartDate']")?.value;
  const registrationEndDate = containerRef.current.querySelector("[name='registrationEndDate']")?.value;
  const startDate = containerRef.current.querySelector("[name='startDate']")?.value;
  const endDate = containerRef.current.querySelector("[name='endDate']")?.value;
  const finalPaymentDate = containerRef.current.querySelector("[name='finalPaymentDate']")?.value;

  if (registrationStartDate && registrationEndDate && new Date(registrationStartDate) >= new Date(registrationEndDate)) {
    alert("Data rozpoczęcia zapisów musi być wcześniejsza niż data zakończenia zapisów.");
    markInvalidInput(containerRef, 'registrationStartDate');
    isValid = false;
  }

  if (registrationEndDate && startDate && new Date(registrationEndDate) >= new Date(startDate)) {
    alert("Data zakończenia zapisów musi być wcześniejsza niż data rozpoczęcia wycieczki.");
    markInvalidInput(containerRef, 'registrationEndDate');
    isValid = false;
  }

  if (startDate && endDate && new Date(startDate) >= new Date(endDate)) {
    alert("Data rozpoczęcia wycieczki musi być wcześniejsza niż data zakończenia.");
    markInvalidInput(containerRef, 'startDate');
    isValid = false;
  }

  if (finalPaymentDate && registrationStartDate && new Date(finalPaymentDate) <= new Date(registrationStartDate)) {
    alert("Termin płatności musi być późniejszy niż data rozpoczęcia zapisów.");
    markInvalidInput(containerRef, 'finalPaymentDate');
    isValid = false;
  }

  if (finalPaymentDate && startDate && new Date(finalPaymentDate) >= new Date(startDate)) {
    alert("Termin płatności musi być wcześniejszy niż data rozpoczęcia wycieczki.");
    markInvalidInput(containerRef, 'finalPaymentDate');
    isValid = false;
  }

  const cancelationDateStr = containerRef.current.querySelector("[name='cancelationTripFinalDate']")?.value;
  const suggestedDate = getSuggestedCancellationDate(startDate, endDate);
  
  if (cancelationDateStr && suggestedDate) {
    const cancelationDate = new Date(cancelationDateStr);
    cancelationDate.setHours(0, 0, 0, 0); 
  
    if (cancelationDate > suggestedDate) {
      alert("Data maksymalnego terminu odwołania wycieczki nie może być późniejsza niż sugerowana: " + suggestedDate.toLocaleDateString("pl-PL")
      );
      markInvalidInput(containerRef, "cancelationTripFinalDate");
      isValid = false;
    }
  }

  if (cancelationDateStr && registrationStartDate) {
    const cancelationDate = new Date(cancelationDateStr);
    cancelationDate.setHours(0, 0, 0, 0);
    const registrationStart = new Date(registrationStartDate);
    registrationStart.setHours(0, 0, 0, 0);
  
    if (cancelationDate < registrationStart) {
      alert(
        "Data maksymalnego terminu odwołania wycieczki nie może być wcześniejsza niż data rozpoczęcia zapisów: " +
        registrationStart.toLocaleDateString("pl-PL")
      );
      markInvalidInput(containerRef, "cancelationTripFinalDate");
      isValid = false;
    }
  }

  const borderOutboundDateStr = containerRef.current.querySelector("[name='borderCrossingOutboundDate']")?.value;
  const borderReturnDateStr = containerRef.current.querySelector("[name='borderCrossingReturnDate']")?.value;

  const variantStartDateStr = startDate;
  const variantEndDateStr = endDate;
  
  const stripTime = (dateStr) => {
    const d = new Date(dateStr);
    d.setHours(0, 0, 0, 0);
    return d;
  };
  
  if (borderOutboundDateStr && borderReturnDateStr && variantStartDateStr && variantEndDateStr) {
    const borderOutbound = stripTime(borderOutboundDateStr);
    const borderReturn = stripTime(borderReturnDateStr);
    const variantStart = stripTime(variantStartDateStr);
    const variantEnd = stripTime(variantEndDateStr);
  
    if (borderOutbound < variantStart || borderOutbound > variantEnd) {
      alert("Data przekroczenia granicy (wyjazd) musi mieścić się w zakresie dat rozpoczęcia i zakończenia wycieczki.");
      markInvalidInput(containerRef, "borderCrossingOutboundDate");
      isValid = false;
    }
  
    if (borderReturn < variantStart || borderReturn > variantEnd) {
      alert("Data przekroczenia granicy (powrót) musi mieścić się w zakresie dat rozpoczęcia i zakończenia wycieczki.");
      markInvalidInput(containerRef, "borderCrossingReturnDate");
      isValid = false;
    }
  
    if (borderReturn < borderOutbound) {
      alert("Data przekroczenia granicy (powrót) nie może być wcześniejsza niż data przekroczenia granicy (wyjazd).");
      markInvalidInput(containerRef, "borderCrossingReturnDate");
      isValid = false;
    }
  }

  return isValid;
};


const validateElementInputs = (containerRef) => {
  const inputs = containerRef.current.querySelectorAll("input, textarea, select");
  let isValid = true;

  inputs.forEach((input) => {
    if (!input.checkValidity()) {
      input.classList.add("invalidInput");
      input.reportValidity();
      isValid = false;
    } else {
      input.classList.remove("invalidInput");
    }
  });

  const elementDate = containerRef.current.querySelector("input[name='startDate']")?.value;
  const elementInput = containerRef.current.querySelector("input[name='startDate']");
  const variantStartDate = document.querySelector("input[name='startDate']")?.value;
  const variantEndDate = document.querySelector("input[name='endDate']")?.value;

  if (elementDate && variantStartDate && variantEndDate) {
    const elementDateObj = new Date(elementDate);
    const start = new Date(variantStartDate);
    const end = new Date(variantEndDate);

    if (elementDateObj < start || elementDateObj > end) {
      alert(
        "Data elementu musi zawierać się w zakresie dat wycieczki: " +
        formatDateTime(variantStartDate) +
        " – " +
        formatDateTime(variantEndDate) +
        "."
      );
      if (elementInput) {
        elementInput.classList.add("invalidInput");
        elementInput.scrollIntoView({ behavior: "smooth", block: "center" });
        elementInput.focus();
      }
      isValid = false;
    }
  }

  return isValid;
};
export  {validateVariantInputs, validateElementInputs};
